import {faq} from './faq.js';
import {consentInfo} from './consent.js';

export let serviceContent = (function (angular) {

    window.app.controller('serviceContent', ['$scope', '$http', '$compile', function ($scope, $http, $compile) {
        $scope.data = {
            consent : consentInfo,
    
            bikLandingFaq: faq
        }

        $scope.setServiceData($scope.data);
        
    }])

})(window.angular);


// WEBPACK FOOTER //
// src/js/controllers/serviceContent/index.js